import React from "react";

// Third Party
import { FiMoon as FiMoonIcon, FiSun as FiSunIcon } from "react-icons/fi";

// Context
import { useTheme } from "../../context/theme/ThemeContext";

const FiMoon = FiMoonIcon as React.FC<any>;
const FiSun = FiSunIcon as React.FC<any>;

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  const label = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <button
      type="button"
      className={`theme-toggle ${isDark ? "is-dark" : "is-light"}`}
      onClick={toggleTheme}
      aria-label={label}
      aria-pressed={isDark}
      title={label}
    >
      <span className="theme-toggle__track">
        <span className="theme-toggle__thumb">
          {isDark ? <FiMoon /> : <FiSun />}
        </span>
      </span>
    </button>
  );
};

export default ThemeToggle;
